import {get,post} from "@/api/http";
import {searchHttp,searchHttpDev} from "@/api/config";
let searchHref = process.env.NODE_ENV === "production" ? (/\/\/www\./.test(window.location.origin) ? searchHttp : searchHttpDev) : searchHttpDev;
// 首页轮播
export const getCourseAdSolts = (data) => get('/v1/ocs/getCourseAdSolts.jspx', data);
// 获取各种云课堂列表
export const getCoursePageTypeCourses = (data) => get('/v1/ocs/getCoursePageTypeCourses.jspx', data);
// 获取视频详情
// export const getCourseDetail = (data) => get('/v1/ocs/getCourseDetail.jspx', data);
export const getCourseDetail = (data) => get('/v2/ocs/getCourseDetail.jspx', data);
// 获取名师列表
export const getFamousSpeakers = (data) => get('/v3/ocs/getFamousSpeakers.jspx', data);
// 根据讲者id获取课程列表
export const getFamousSpeakerCourses = (data) => get('/v1/ocs/getFamousSpeakerCourses.jspx', data);
// 即将上线
export const getComingOnlineCourses = (data) => get('/v1/ocs/getComingOnlineCourses.jspx', data);
// 课程播放页获取相关课程
export const getCurrentCourses = (data) => get('/v1/ocs/getCurrentCourses.jspx', data);
// 根据vid获取视频链接
export const getPlayAuth = (data) => get("/v1/ocs/getPlayAuth.jspx", data);
// 获取用户对当前课程的各种状态（是否收藏，是否评分，是否点赞，是否购买）
export const getUserCourseStatus = (data) => get("/v1/ocs/getUserCourseStatus.jspx", data);
// 视频收藏
export const courseCollect = (data) => post("/v1/ocs/courseCollect.jspx", data);
// 获取评论列表
export const getCourseCommentPage = (data) => get("/v1/ocs/getCourseCommentPage.jspx", data);
// 发送评论
export const saveComment = (data) => post("/v1/ocs/saveComment.jspx", data);
// 评论点赞
export const commentDigg = (data) => post("/v1/ocs/commentDigg.jspx", data);
// 我的课程
export const getPcUserCourses = (data) => get("/v1/ocs/getPcUserCourses.jspx", data);
// 播放记录(浏览+1)
export const savePlayRecord = (data) => post("/v1/ocs/savePlayRecord.jspx", data);
// 随机获取免费课程
export const getPcFreeCourseList = (data) => get("/v1/ocs/getPcFreeCourseList.jspx", data);
// 首页名师列表
export const getHomepageShowSpeakers = (data) => get("/v1/ocs/getHomepageShowSpeakers.jspx", data);
// 获取用户info
export const getPersonalWebsite = (data) => get("/v2/personal/getPersonalWebsite.jspx", data);
// 云课堂搜索
export const search = (data) => get(searchHref + "/v8/search.jspx", data);
// 采集云课堂浏览历史
export const saveBrowsingHistory = (data) => post("/v1/cms/saveBrowsingHistory.jspx", data);
// 获取活动详情
export const getActivityInfo = (data) => get("/moocActivity/getActivityInfo.jspx", data);
// 修改证书的名字
export const saveActivityUser = (data) => post("/moocActivity/saveActivityUser.jspx", data);
// 兑换证书请求
export const exchangeGoods = (data) => post("/moocActivity/exchangeGoods.jspx", data);
// 请求兑换的证书信息
export const getExchangeInfo = (data) => get("/moocActivity/getExchangeInfo.jspx", data);
// 生成支付订单
// export const saveOrder = (data) => post("/v2/ocs/native/saveOrder.jspx", data);
export const saveOrder = (data) => post("/v3/ocs/saveOrder.jspx", data);
// 取消订单
export const cancelOrder = (data) => post("/v1/ocs/cancelOrder.jspx", data);
// 删除订单
export const deleteOrder = (data) => post("/v1/ocs/deleteOrder.jspx", data);
// 生成预支付订单 微信或者支付宝
export const pay = (data) => post("/v1/ocs/native/pay.jspx", data);
// Wx查询订单
export const wxOrderQuery = (data) => get("/v1/ocs/wxOrderQuery.jspx", data);
// Ali查询订单
export const aliOrderQuery = (data) => get("/v1/ocs/aliOrderQuery.jspx", data);
// 确认支付结果
export const verifyPayment = (data) => post("/ocs/verifyPayment.jspx", data);
// 获取用户优惠券
export const getUserCouponsByCourse = (data) => get("/v1/ocs/getUserCouponsByCourse.jspx", data);
// export const getUserCoupons = (data) => get("/v4/ocs/getUserCoupons.jspx", data);
// 后去用户余额
export const getUserWallet = (data) => get("/v1/shenbei/getUserWallet.jspx", data);
// 神贝充值费率表
export const getShenbeiRateList = (data) => get("/v1/shenbei/getShenbeiRateList.jspx", data);
// 神贝支付订单课程
export const shenbeiorder = (data) => post("/v1/shenbei/order.jspx", data);
// 神贝预支付 收款平台
export const shenbeipay = (data) => post("/v1/shenbei/native/pay.jspx", data);
// 神贝支付
// export const shenbeiPay = (data) => post("/v1/ocs/shenbeiPay.jspx", data);
// 获取用户未完成任务列表
export const getUserNotOverTaskList = (data) => get("/grow/userGrow/getUserNotOverTaskList.jspx", data);
// 获取任务完成状态
export const getTaskCompleteStatus = (data) => get("/grow/userGrow/getTaskCompleteStatus.jspx", data);
// 提交任务
export const postUserTaskRecord = (data) => post("/grow/userGrow/postUserTaskRecord.jspx", data);
// 广告版位
export const getSlotContent = (data) => get("/slot/v3/getSlotContent.jspx", data);
// 勋章
export const saveWatchVideoRecord = (data) => post("/grow/medal/saveWatchVideoRecord.jspx", data);
// 勋章获取视频进度要求值信息
export const findProgressValueList = (data) => get("/grow/medal/findProgressValueList.jspx", data);
// 获取兑换券
export const getUserExchangeVoucherList = (data) => get("/v1/ocs/getUserExchangeVoucherList.jspx", data);
